import React from 'react';
import {
  GridColStyled,
  GridRowStyled,
  TypographyStyledHeader
} from '../../../features/homescreen/style';
import useMediaQuery from '@mui/material/useMediaQuery';
import { defaultTheme } from '../../../styles/theme';
export const DesktopSidePanel = () => {
  const mobileView = useMediaQuery('(max-width:767px)');
  return mobileView ? (
    <></>
  ) : (
    <GridColStyled container style={{ padding: '0px', marginTop: '150px' }}>
      <GridRowStyled
        container
        sx={{ borderInlineStart: '0.3125rem solid #009CDE' }}
      >
        <TypographyStyledHeader
          variant="h1"
          color="common.white"
          style={{ fontWeight: 'bolder', paddingLeft: '0.9375rem' }}
        >
          {'NUTRITION'}
          <span style={{ fontFamily: 'BGThin' }}>{` APP`}</span>
        </TypographyStyledHeader>
      </GridRowStyled>
    </GridColStyled>
  );
};
